import React from "react";
import { BackButton } from "./BackButton";

export const HeaderSection = (props) => {
  return (
    <section className="container">
      <div className="row">
        <div className="col-12 mt-3" style={{ display: "flex" }}>
          <BackButton route={props.route} bgBtnColor={props.bgBtnColor} />
          <small
            className="text-muted"
            style={{ paddingTop: "1rem", paddingLeft: "10px",}}
          >
            {props.resume}
          </small>
        </div>
      </div>
    </section>
  );
};
